function decodeJsonString(value: string): string {
  if (!value.includes('&')) {
    return value;
  }

  return value
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, '\'')
    .replace(/&amp;/g, '&');
}

export function asArray<T = unknown>(value: unknown): T[] {
  if (Array.isArray(value)) {
    return value as T[];
  }

  if (typeof value === 'string' && value.length) {
    // Prefer decoded form when HTML entities are present (&quot; breaks JSON.parse).
    const candidates = value.includes('&')
      ? [decodeJsonString(value), value]
      : [value];

    for (const candidate of candidates) {
      try {
        const parsed: unknown = JSON.parse(candidate);
        if (Array.isArray(parsed)) {
          return parsed as T[];
        }
      } catch {
        // try next candidate
      }
    }

    return [];
  }

  return [];
}
